import { PrivacyPolicyPage } from "@/pages/privacy/page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_pathlessLayout/privacy-policy")({
    component: PrivacyPolicyPage,
});
